import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";

const CLICK_COOLDOWN_MS = 1_000;

const useClickCooldown = (cooldownMs = CLICK_COOLDOWN_MS) => {
  const cooldownEndsAtRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isCooldownActive, setIsCooldownActive] = useState(false);

  const startCooldown = () => {
    // Block additional starts if we're still inside the cooldown window
    if (dayjs().valueOf() < cooldownEndsAtRef.current) {
      return;
    }

    // Mark cooldown end timestamp and flip UI to active
    cooldownEndsAtRef.current = dayjs()
      .add(cooldownMs, "millisecond")
      .valueOf();
    setIsCooldownActive(true);

    // Reset any previous timer before starting a new cooldown timer
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    // Start a new timer, which when ended, will reset everything
    timeoutRef.current = setTimeout(() => {
      cooldownEndsAtRef.current = 0;
      setIsCooldownActive(false);
      timeoutRef.current = null;
    }, cooldownMs);
  };

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    isCooldownActive,
    startCooldown
  };
};

export default useClickCooldown;
